export default {
  layout: {
        zh: '简体中文',
        tc: '繁體中文',
        en: 'English',
        kr: '한국어',
        jp: '日本語',
  },
  footer: {},
  menu: {
      home: 'Home',
      mining: 'Mining Rig',
      wallet: 'Wallet',
      me: 'My Profile',
      login: 'Login'
  },
  home: {
      buy: 'Buy',
      dailyEarnings: 'Daily Earnings',
      topUp: 'Recharge',
      desc: 'Product parameters: Designed for hidden growth and great success',
      popup: {
          buy: 'Buy Now',
          desc: 'Mining rig earnings: 1% daily return (3U/day). Data capsule (35U) must be paid every 30 days to receive earnings, one data capsule included',
          totalAmount: 'Total Amount',
          wallet: 'Fund Wallet',
          revenue: 'Profit Wallet',
          pls: 'Pay with Profit Wallet',
          config: 'Configure Wallet',
          most: 'Max Usage',
          confirmPurchase: 'Confirm Purchase',
          plsDes: 'Enter Referrer',
          confirm: 'Confirm',
      }
  },
  mining: {
      title: 'My Mining Rigs',
      day: 'Total Daily Output',
      activate: 'Unactivated Data Capsules (pcs)',
      miningrig: 'Held Mining Rigs (units)',
      output: 'Producing',
      dataCapsule: 'Data Capsule',
      time: 'Purchase Time',
      remaining: 'Remaining Days (days)',
      today: "Today's Output",
      total: 'Total Output',
      expired: 'Expiring Soon',
      stop: 'Stopped Production',
  },
  record: {
      title: 'Account Records',
      empty: 'No Records',
      wallet: 'Fund Wallet',
      time: 'Date',
      remark: 'Note: Released per point',
      complimentary: 'Note: Complimentary',
      static: 'Note: Static Income',
  },
  wallet: {
      title: 'My Wallet',
      record: 'Fund Records',
      static: 'Daily Static Income',
      dynamic: 'Daily Dynamic Rewards',
      topup: 'Recharge',
      withdraw: 'Withdraw',
      totalRevenue: 'Total Mining Rig Earnings',
      totalReward: 'Total Rewards',
      funds: 'Fund Wallet',
    fund1: 'Fund Wallet',
        fund2: 'Earnings Wallet',
        fund3: 'Allocation Wallet',
  },
  withdraw: {
      title: 'Withdraw',
      revenue: 'Profit Wallet',
      amount: 'Withdrawal Amount',
      confirm: 'Confirm Withdrawal',
      rule: 'Withdrawal Rules',
      desc: 'Withdrawal fee: 5U or 5% per transaction, whichever is higher',
      desc1: 'Minimum withdrawal amount: 10U',
      list: 'Withdrawal List',
      success: 'Success',
      time: 'Date',
      error: 'Failed',
  },
  me: {
      recommend: 'My Referrer',
      subscription: 'Subscription Performance',
      directReferral: 'Direct Referral Performance',
      team: 'My Team (people)',
      performance: 'Team Performance',
      serialNumber: 'Serial Number',
      level: 'Level',
      individual: 'Individual Performance',
      time: 'Registration Date',
      home: 'Home',
      last: 'Last',
  },
};